import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allDataCollectionForms: [],
    questions: [],
    loading: false,
    error: null,
};

const dataCollectionSlice = createSlice({
    name: 'dataCollection',
    initialState,
    reducers: {
        setAllDataCollectionForms: (state, action) => {
            state.allDataCollectionForms = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
        setQuestions: (state, action) => {
            state.questions = action.payload;
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllDataCollectionForms, setQuestions } = dataCollectionSlice.actions;

export default dataCollectionSlice.reducer;